<div class="badges">
	<slot />
</div>

<style lang="postcss">
	.badges {
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;
	}
</style>
